import type { ReactNode } from 'react'
import { Info } from 'lucide-react'

/** Плашка-подсказка в панели настроек элемента (таблица, картинка). */
export const HintBox = ({ children }: { children: ReactNode }) => (
  <div className="flex gap-2 rounded-lg border border-border bg-muted/50 p-3 text-xs text-muted-foreground">
    <Info className="mt-0.5 size-3.5 shrink-0" />
    <span>{children}</span>
  </div>
)
